import Hero from './Hero';

export default Hero;



// WEBPACK FOOTER //
// ./src/components/HomePage/components/Hero/index.js